'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('../../../../dist-es6/shared/domain/fatigueMeterType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');

const getHelpCenterLinks=require('./getHelpCenterLinks');
const HelpDeskPhoneNumber='877.791.0989';let

HelpCenterController=function(_BaseController){_inherits(HelpCenterController,_BaseController);
function HelpCenterController(uncaughtErrorHandler,breadcrumbsService,userService){_classCallCheck(this,HelpCenterController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

breadcrumbsService.startTrail('Help Center');

const fatigueMeterType=_.get(userService,'currentUser.fatigueMeterType',FatigueMeterType.Trucking);

_this._links=getHelpCenterLinks(fatigueMeterType);return _this;
}_createClass(HelpCenterController,[{key:'helpDeskPhoneNumber',get:function()

{
return HelpDeskPhoneNumber;
}},{key:'links',get:function()

{
return this._links;
}}]);return HelpCenterController}(BaseController);


module.exports=HelpCenterController;
//# sourceMappingURL=helpCenterController.js.map
